var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoockie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.15,27.23C26,27.46,26,37.77,33.15,38,40.26,37.76,40.25,27.45,33.15,27.23Zm0,8.76a3.38,3.38,0,0,1,0-6.76A3.38,3.38,0,0,1,33.15,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,17a3.64,3.64,0,0,0,0,7.28A3.64,3.64,0,0,0,18,17Zm0,5.28A1.64,1.64,0,0,1,18,19,1.64,1.64,0,0,1,18,22.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.71,38.37a3.64,3.64,0,0,0,0,7.28A3.64,3.64,0,0,0,43.71,38.37Zm0,5.28a1.64,1.64,0,0,1,0-3.28A1.64,1.64,0,0,1,43.71,43.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.67,15.13a3.64,3.64,0,0,0-4.47,5.74A3.64,3.64,0,0,0,38.67,15.13ZM37.73,19a1.64,1.64,0,0,1-2.59-2A1.64,1.64,0,0,1,37.73,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.47,44.38c-6.13-.9-7.67,8.07-1.59,9.27C36,54.55,37.56,45.59,31.47,44.38Zm1.87,5.09A2.7,2.7,0,0,1,28,48.56,2.7,2.7,0,0,1,33.34,49.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.56,35.25a1,1,0,0,0-.87-.26,3.9,3.9,0,0,1-2.6-.48,3.84,3.84,0,0,1-1.89-3.64,1,1,0,0,0-1-1.08A5.6,5.6,0,0,1,51.47,29a5.72,5.72,0,0,1-.44-9.5,1,1,0,0,0-.3-1.85A5.05,5.05,0,0,1,47,13.38a1,1,0,0,0-1.4-.78,3.88,3.88,0,0,1-5-5.21,4.1,4.1,0,0,1,1-1.26,1,1,0,0,0-.34-1.7C17.28-3.33-4.63,21,5.71,43.93a29,29,0,0,0,55.14-7.82A1,1,0,0,0,60.56,35.25ZM43.25,56.61C21.51,66.48-1.64,44.74,6.89,22.45,11.41,9.73,26.12,2.23,39.08,5.9c-2.88,4.3,1.21,10,6.14,8.9A7.06,7.06,0,0,0,48.64,19c-4.1,4.35-1.35,12,4.57,12.73A5.9,5.9,0,0,0,58.67,37,26.88,26.88,0,0,1,43.25,56.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.83,35.4c-3.39-4.55-10.19.25-7,5,3.41,4.56,10.19-.25,7-5Zm-2.19,4.37A2.3,2.3,0,0,1,14,36,2.3,2.3,0,0,1,16.64,39.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoockie);
export default __webpack_public_path__ + "static/media/coockie.2197abaa77de9f9bc039d6b27a49f449.svg";
export { ForwardRef as ReactComponent };